/**
 * @file Tag + state for the entity the local player drives.
 *
 * The component carries no input handling: it stores the resolved intent so
 * other systems (camera, audio, HUD) can read where the player is aiming
 * without depending on the input device.
 */

import * as THREE from 'three';
import { Component } from '../ecs/Component.js';

export class PlayerControlled extends Component {
  constructor() {
    super();
    /** @type {THREE.Vector3} World point the player is aiming at, on the ground plane. */
    this.aimPoint = new THREE.Vector3();
    /** @type {number} Distance travelled since the last footstep event. */
    this.stepDistance = 0;
    /** @type {number} Seconds left on an active dash. */
    this.dashRemaining = 0;
    /** @type {number} Seconds until dash can fire again. */
    this.dashCooldown = 0;
    /** @type {number} Locked dash direction X while dashing. */
    this.dashDirX = 0;
    /** @type {number} Locked dash direction Z while dashing. */
    this.dashDirZ = 0;
    /** @type {boolean} True after this dash has stunned an enemy. */
    this.dashHit = false;
  }

  /** @returns {void} */
  reset() {
    this.aimPoint.set(0, 0, 0);
    this.stepDistance = 0;
    this.dashRemaining = 0;
    this.dashCooldown = 0;
    this.dashDirX = 0;
    this.dashDirZ = 0;
    this.dashHit = false;
  }
}
